import React from 'react'
import moment from 'moment'

class CanvasComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    if (this.props.ticks.length > 0) {
      let priceMin = this.props.ticks.reduce((p, v) => Math.min(p, v.BidPrice), this.props.ticks[0].BidPrice);
      let priceMax = this.props.ticks.reduce((p, v) => Math.max(p, v.AskPrice), this.props.ticks[0].AskPrice);

      priceMin = this.props.points.reduce((p, v) => v.value ? Math.min(p, v.value) : p, priceMin);
      priceMax = this.props.points.reduce((p, v) => v.value ? Math.max(p, v.value) : p, priceMax);

      this.minT = Math.floor(this.props.timeRange.from / this.props.grid.time) * this.props.grid.time;
      this.maxT = Math.ceil(this.props.timeRange.to / this.props.grid.time) * this.props.grid.time;

      this.minV = Math.floor(priceMin / this.props.grid.value) * this.props.grid.value;
      this.maxV = Math.ceil(priceMax / this.props.grid.value) * this.props.grid.value;

      this.scaleX = this.props.width / (this.maxT - this.minT);
      this.scaleY = this.props.height / (this.maxV - this.minV);
    }

    this.pt_width = 10;

    // initial state
    this.state = {};
  };

  componentDidMount() {
    this.updateCanvas();
  }

  drawTicks(ctx, bid_or_ask) {
    ctx.strokeStyle = (bid_or_ask === 'BidPrice') ? this.props.bidColor : this.props.askColor;
    ctx.beginPath();
    for (let i = 1; i < this.props.ticks.length; i++) {
      let t1 = this.props.ticks[i - 1];
      let t2 = this.props.ticks[i];

      ctx.moveTo(this.timeToX(t1.Time), this.valueToY(t1[bid_or_ask]));
      ctx.lineTo(this.timeToX(t2.Time), this.valueToY(t2[bid_or_ask]));
    }
    ctx.closePath();
    ctx.stroke();

    ctx.fillStyle = ctx.strokeStyle;
    for (let i = 0; i < this.props.ticks.length; i++) {
      let t = this.props.ticks[i];
      let x = this.timeToX(t.Time);
      let y = this.valueToY(t[bid_or_ask]);
      ctx.fillRect(x - this.pt_width * 0.5, y - this.pt_width * 0.5, this.pt_width, this.pt_width);
    }
  }

  updateCanvas() {
    const ctx = this.refs.canvas.getContext('2d');
    ctx.save();
    ctx.fillStyle = this.props.bgColor;
    ctx.fillRect(0, 0, this.props.width, this.props.height);

    if (this.props.ticks.length === 0) {
      return;
    }

    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.strokeStyle = this.props.gridColor;

    const stepByX = this.props.grid.time * this.scaleX;

    ctx.beginPath();
    for (let x = stepByX; x < this.props.width; x += stepByX) {
      ctx.moveTo(x, 0);
      ctx.lineTo(x, this.props.height);
    }
    ctx.stroke();

    const stepByY = this.props.grid.value * this.scaleY;
    ctx.beginPath();
    for (let y = stepByY; y < this.props.height; y += stepByY) {
      ctx.moveTo(0, y);
      ctx.lineTo(this.props.width, y);
    }
    ctx.stroke();

    this.drawTicks(ctx, 'BidPrice');
    this.drawTicks(ctx, 'AskPrice');

    ctx.fillStyle = this.props.ptColor;
    ctx.strokeStyle = this.props.ptColor;

    for (let i = 0; i < this.props.points.length; i++) {
      let p = this.props.points[i];
      let x = this.timeToX(p.Time);
      if (p.Value) {
        let y = this.valueToY(p.Value);
        ctx.fillRect(x - this.pt_width * 0.5, y - this.pt_width * 0.5, this.pt_width, this.pt_width);
      } else {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, this.props.height);
        ctx.stroke();
      }
    }

    ctx.fillStyle = "#000000";
    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";
    let textT0V0 = moment.utc(this.minT).format("YYYY-MM-DD HH:mm:ss") + ", " + this.minV.toFixed(5);
    ctx.fillText(textT0V0, 0, this.props.height);

    ctx.textBaseline = "top";
    ctx.textAlign = "right";
    let textT1V1 = moment.utc(this.maxT).format("YYYY-MM-DD HH:mm:ss") + ", " + this.maxV.toFixed(5);
    ctx.fillText(textT1V1, this.props.width, 0);
    ctx.restore();
  }

  timeToX(time) {
    return this.scaleX * (time - this.minT)
  }

  valueToY(v) {
    return this.scaleY * (this.maxV - v);
  }

  render() {
    return (
      <canvas ref="canvas" width={this.props.width} height={this.props.height}/>
    );
  }
}

CanvasComponent.defaultProps = {
  bgColor: "#7F7F7F",
  width: 600,
  height: 200,
  timeRange: {from: 0, to: 10000},
  grid: {time: 1000, value: 0.01},
  gridColor: "#8F8F8F",
  bidColor: "#8F0000",
  askColor: "#00008F",
  ptColor: "#008F00",
  ticks: [],
  points: []
};

export default CanvasComponent;



// WEBPACK FOOTER //
// ./src/js/Component/TicksGraph.jsx